import React from 'react';
export const ContextApi = React.createContext()


// WEBPACK FOOTER //
// ./src/components/context/ContextApi.js